import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataTableComponent, DomChangeDirective } from './controls/data-table/data-table.component';
import { NumberInputComponent } from './controls/number-input/number-input.component';
import { MessageBoxComponent } from './popups/message-box/message-box.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    DataTableComponent,
    DomChangeDirective,
    NumberInputComponent,
    MessageBoxComponent
  ],

  exports: [
    DataTableComponent,
    NumberInputComponent,
    MessageBoxComponent
  ],
  entryComponents: [
    MessageBoxComponent
  ]
})
export class JvUiModule { }
